export default "__VITE_ASSET__5596ea86__"